module.exports = __webpack_public_path__ + "static/media/server2.da40ba68.png";